/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import WorkIcon from '@mui/icons-material/Work'
import SchoolIcon from '@mui/icons-material/School'

import { positionChangeWidthSm, navbarHeight, footerHeight, bumbleProfileImageWidth, bumbleLeadImageHeight, bumbleImageHeight, bumbleProfileBackgroundColor, bumbleProfileItemBorderColor, bumbleProfileItemDividerOpacity, bumbleProfileItemBoxShadow, bumbleProfileItemBorderWidth, bumbleProfileItemBorderRadius, swipelyticsTurquoise, profPicDefaultURL } from '../../../../../helpers/variableDefaults'

export const viewBumbleNameAndProfessionItem = (datingProfile, width) => {
  return (
    <>
      {/* Overlay */}
      <Box
        sx={{
          width: bumbleProfileImageWidth(width),
          // position: 'absolute',
          height: bumbleLeadImageHeight(width) * .18,
          backgroundColor: 'black',
          boxShadow: '0px -5px 10px black',
          opacity: .25,
        }}
      />

      {/* Name, Age, Profession, Education */}
      <Box
        sx={{
          width: bumbleProfileImageWidth(width),
          position: 'absolute',
          height: bumbleLeadImageHeight(width) * .18,
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >

        {/* Name, Age */}
        <Typography
          sx={{
            pb: 0, pl: 2,
            fontWeight: 'bolder',
            fontSize: '22px',
            color: 'white',
          }}
        >
          {datingProfile.bio.vitalInfo.firstName}, {datingProfile.bio.vitalInfo.age}
        </Typography>

        {/* Profession and Employer */}
        {
          (
            (
              'profession' in datingProfile.bio.vitalInfo 
              && datingProfile.bio.vitalInfo.profession.length > 0
            )
            ||
            (
              'employer' in datingProfile.bio.vitalInfo 
              && datingProfile.bio.vitalInfo.employer.length > 0
            ) 
          )
          &&
          <>
            {/* Profession and Employer */}
            <Box
              sx={{
                pb: 0, pl: 2,
                width: '100%',
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <WorkIcon sx={{ mr: 1, mt: .5, width: '15px', height: '15px', color: 'white' }} />

              {/* Profession and Employer */}
              <Typography
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                  textOverflow: 'clip',
                  overflow: 'hidden',
                }}
              >
                {
                  'profession' in datingProfile.bio.vitalInfo 
                  && datingProfile.bio.vitalInfo.profession.length > 0
                  && 'employer' in datingProfile.bio.vitalInfo
                  && datingProfile.bio.vitalInfo.employer.length > 0
                    ?
                    `${datingProfile.bio.vitalInfo.profession} at ${datingProfile.bio.vitalInfo.employer}` 
                    // `${datingProfile.bio.vitalInfo.profession}` 
                    :
                    'profession' in datingProfile.bio.vitalInfo 
                    && datingProfile.bio.vitalInfo.profession.length > 0
                      ?
                      `${datingProfile.bio.vitalInfo.profession}`
                      :
                      `${datingProfile.bio.vitalInfo.employer}`
                }
              </Typography>
              
            </Box>
          </>
        }
        

        {/* University */}
        {
          (
            'university' in datingProfile.bio.vitalInfo 
            && datingProfile.bio.vitalInfo.university.length > 0
          )
          &&
          <>
            {/* University */}
            <Box
              sx={{
                pb: 0, pl: 2,
                width: '100%',
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
                flexWrap: 'nowrap',
              }}
            >

              {/* Icon */}
              <SchoolIcon sx={{ mr: 1, mt: .5, width: '15px', height: '15px', color: 'white' }} />

              {/* University */}
              <Typography
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                  textOverflow: 'clip',
                  overflow: 'hidden',
                }}
              >
                {`${datingProfile.bio.vitalInfo.university}`}
              </Typography>
              
            </Box>
          </>
        }

      </Box>
    </>
  )
}